<template>
    <div>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="right"
            label-width="150px"
        >
            <div class="header">
                <div>基本信息</div>
            </div>
            <el-row>
                <!-- <el-col :span="16"> -->
                <el-col :span="8">
                    <el-form-item label="身份证号" prop="sfzhm">
                        <el-input
                            v-model="form.sfzhm"
                            placeholder="请输入"
                            :readonly="true"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="姓名" prop="xm">
                        <el-input
                            v-model="form.xm"
                            placeholder="请输入"
                            :readonly="true"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="性别" prop="xb">
                        <el-select v-model="form.xb" style="width: 100%">
                            <el-option
                                v-for="item in options.genderList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="民族" prop="mz">
                        <el-select
                            v-model="form.mz"
                            filterable
                            placeholder="请输入（可搜索）"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in options.nationList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="出生年月" prop="csny">
                        <el-date-picker
                            v-model="form.csny"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="政治面貌" prop="zzmm">
                        <el-select v-model="form.zzmm" style="width: 100%">
                            <el-option
                                v-for="item in options.politicsFaceList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="手机号码" prop="sjhm">
                        <el-input
                            v-model="form.sjhm"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="籍贯" prop="jg">
                        <el-cascader
                            style="width: 100%"
                            clearable
                            :options="selectJg"
                            v-model="form.jg"
                        >
                        </el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="家庭住址" prop="jtzz">
                        <el-input
                            v-model="form.jtzz"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row> 
                <el-col :span="8">
                    <el-form-item label="视力" prop="sl">
                        <el-select v-model="form.sl" style="width: 100%">
                            <el-option
                                v-for="item in options.slList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="身高" prop="sg">
                        <el-select v-model="form.sg" style="width: 100%">
                            <el-option
                                v-for="item in options.sgList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="体重" prop="tz">
                        <el-select
                            v-model="form.tz"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in options.tzList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="header">
                <div>学习及工作经历</div>
            </div>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="最高学历" prop="dyxl">
                        <el-select
                            v-model="form.dyxl"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in options.educationList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="毕业学校" prop="dyxlbyxx">
                        <el-input
                            v-model="form.dyxlbyxx"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="所学专业" prop="dyxlzy">
                        <el-input
                            v-model="form.dyxlzy"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="毕业时间" prop="dyxlbysj">
                        <el-date-picker
                            v-model="form.dyxlbysj"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="参加工作时间" prop="cjgzsj">
                        <el-date-picker
                            v-model="form.cjgzsj"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="现工作单位" prop="xgzdw">
                        <el-input
                            v-model="form.xgzdw"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="现职务或岗位" prop="zwhgw">
                        <el-input
                            v-model="form.zwhgw"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="煤矿井下工作年限" prop="mkjxgznx">
                        <el-select
                            v-model="form.mkjxgznx"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in options.mkjxgznxList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                        label="相关岗位最高技能等级"
                        prop="xggwzgjndj"
                    >
                        <el-select
                            v-model="form.xggwzgjndj"
                            placeholder="请选择"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in options.xggwzgjndjList"
                                :key="item.value"
                                :label="item.value"
                                :value="item.key"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="相关岗位操作资格证" prop="xggwczzgz">
                        <el-input
                            v-model="form.xggwczzgz"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="个人履历" prop="gzpxxxjl">
                        <el-input
                            v-model="form.gzpxxxjl"
                            type="textarea"
                            placeholder="xx年至xx年，在xx单位从事xx井下工作"
                            maxlength="500"
                            show-word-limit
                        ></el-input>
                        <div class="input-tip">
                            注意！输入格式为：xx年至xx年，在xx单位从事xx井下工作
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>

            <div class="header">
                <div>其他</div>
            </div>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注" prop="bz">
                        <el-input v-model="form.bz" type="textarea"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="header" style="margin-bottom: 10px">
                <div>
                    附件上传<span
                        style="color: red; margin-left: 5px; font-size: 13px"
                        >（注意：上传格式统一为PDF或JPG，单个上传文件不能超过2M。）</span
                    >
                </div>
            </div>
            <div class="attachments-section">
                <el-row :gutter="10">
                    <!-- 身份证上传 -->
                    <el-col :span="8">
                        <div class="attachment-card">
                            <div class="card-header">
                                <i class="el-icon-document"></i>
                                <span>身份证</span>
                                <span class="required">*</span>
                            </div>
                            <div class="card-body">
                                <el-upload
                                    action=""
                                    :multiple="false"
                                    :on-change="sfzUploadChange"
                                    :auto-upload="false"
                                    :limit="1"
                                    :show-file-list="false"
                                    accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
                                    class="upload-demo"
                                    ref="sfzRef"
                                >
                                    <el-button size="small" type="primary"
                                        >点击上传</el-button
                                    >
                                </el-upload>
                                <div class="file-list">
                                    <div
                                        v-for="(
                                            item, index
                                        ) in sfzFileSuccessList"
                                        :key="item.uid"
                                        class="file-item"
                                    >
                                        <i class="el-icon-document"></i>
                                        <span class="file-name">{{
                                            item.raw.name
                                        }}</span>
                                        <i
                                            class="el-icon-delete delete-icon"
                                            @click="deleteFile(index, '1')"
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>

                    <!-- 毕业证上传 -->
                    <el-col :span="8">
                        <div class="attachment-card">
                            <div class="card-header">
                                <i class="el-icon-document"></i>
                                <span>毕业证</span>
                                <span class="required">*</span>
                            </div>
                            <div class="card-body">
                                <el-upload
                                    action=""
                                    :multiple="false"
                                    :on-change="byzUploadChange"
                                    :auto-upload="false"
                                    :limit="5"
                                    accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
                                    class="upload-demo"
                                    ref="byzRef"
                                >
                                    <el-button size="small" type="primary"
                                        >点击上传</el-button
                                    >
                                </el-upload>
                                <div class="file-list">
                                    <div
                                        v-for="(
                                            item, index
                                        ) in byzFileSuccessList"
                                        :key="item.uid"
                                        class="file-item"
                                    >
                                        <i class="el-icon-document"></i>
                                        <span class="file-name">{{
                                            item.raw.name
                                        }}</span>
                                        <i
                                            class="el-icon-delete delete-icon"
                                            @click="deleteFile(index, '2')"
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>

                    <!-- 技能证书上传 -->
                    <el-col :span="8">
                        <div class="attachment-card">
                            <div class="card-header">
                                <i class="el-icon-document"></i>
                                <span>应聘岗位相关技能等级证或岗位资格证</span>
                                <span class="required">*</span>
                            </div>
                            <div class="card-body">
                                <el-upload
                                    action=""
                                    :multiple="false"
                                    :on-change="gwzgzUploadChange"
                                    :auto-upload="false"
                                    :limit="5"
                                    accept=".pdf,.jpg,.jpeg,application/pdf,image/jpeg"
                                    class="upload-demo"
                                    ref="gwzgzRef"
                                >
                                    <el-button size="small" type="primary"
                                        >点击上传</el-button
                                    >
                                </el-upload>
                                <div class="file-list">
                                    <div
                                        v-for="(
                                            item, index
                                        ) in gwzgzFileSuccessList"
                                        :key="item.uid"
                                        class="file-item"
                                    >
                                        <i class="el-icon-document"></i>
                                        <span class="file-name">{{
                                            item.raw.name
                                        }}</span>
                                        <i
                                            class="el-icon-delete delete-icon"
                                            @click="deleteFile(index, '3')"
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>

                <!-- 通用附件上传区域 -->
                <!-- <div class="general-attachments">
                <div class="card-header">
                    <i class="el-icon-folder"></i>
                    <span>其他附件（可选）</span>
                </div>
                <div class="upload-area">
                    <el-upload
                    action=""
                    :multiple="true"
                    :on-change="uploadChange"
                    :auto-upload="false"
                    :limit="10"
                    class="upload-demo">
                    <el-button size="small" type="primary">选择文件</el-button>
                    <div slot="tip" class="el-upload__tip">可上传最多10个文件，支持PDF/JPG格式</div>
                    </el-upload>
                </div>
                
                <div class="file-list-container" v-if="fileSuccessList.length > 0 || fileFailList.length > 0">
                    <div class="file-section" v-if="fileSuccessList.length > 0">
                    <div class="section-title success-title">上传成功</div>
                    <div class="file-grid">
                        <div 
                        v-for="(item, index) in fileSuccessList" 
                        :key="item.uid"
                        class="file-item success-item">
                        <i class="el-icon-document"></i>
                        <span class="file-name">{{ item.raw.name }}</span>
                        <i class="el-icon-delete delete-icon" @click="deleteFile(index)"></i>
                        </div>
                    </div>
                    </div>
                    
                    <div class="file-section" v-if="fileFailList.length > 0">
                    <div class="section-title fail-title">上传失败</div>
                    <div class="file-grid">
                        <div 
                        v-for="(item, index) in fileFailList" 
                        :key="item.uid"
                        class="file-item fail-item">
                        <i class="el-icon-document"></i>
                        <span class="file-name">{{ item.raw.name }}</span>
                        <div class="file-actions">
                            <span class="retry-text" @click="reUploadFile(index)">重新上传</span>
                            <i class="el-icon-delete delete-icon" @click="removeFile(index)"></i>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div> -->
            </div>
        </el-form>
    </div>
</template>

<script>
import share from "@/assets/sharejs/share.js";
import request from "@/api/postList.js";
import { provinceAndCityData } from "element-china-area-data";

export default {
    mounted() {
        let userInfo = share.get("userInfo");
        this.form.sfzhm = userInfo.yxzjhm;
        this.form.xm = userInfo.xm;
    },
    props: {
        data: {
            type: Object,
        },
    },
    data() {
        return {
            uploadSuccess: false, //是否上传成功
            sfzFileSuccessList: [], //身份证附件上传成功列表
            byzFileSuccessList: [], //毕业证附件上传成功列表
            gwzgzFileSuccessList: [], //岗位资格证附件上传成功列表
            fileList: [], //附件上传文件列表
            fileFailList: [], //附件上传失败列表
            fileSuccessList: [], //附件上传成功列表
            selectJg: provinceAndCityData,

            form: {
                xm: "", //姓名
                sfzhm: "", //身份证号
                xb: "", //性别
                mz: "", //民族
                csny: "", //出生年月
                zzmm: "", //政治面貌
                sjhm: "", //手机号码
                jg: [], //籍贯
                jtzz: "", //家庭住址
                sl: "", //视力
                sg: "", //身高
                tz: "", //体重
                dyxl: "", //学历
                dyxlbyxx: "", //毕业学校
                dyxlzy: "", //所学专业
                dyxlbysj: "", //毕业时间
                cjgzsj: "", //参加工作时间
                xgzdw: "", //现工作单位
                zwhgwgw: "", //职务或岗位
                mkjxgznx: "", //煤矿井下工作年限
                xggwzgjndj: "", //相关岗位最高技能等级
                xggwczzgz: "", //相关岗位操作资格证
                gzpxxxjl: "", //个人履历
                bz: "", //备注
            },
            rules: {
                xm: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: ["blur", "change"],
                    },
                ],
                sfzhm: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: ["blur", "change"],
                    },
                ],
                xb: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: ["blur", "change"],
                    },
                ],
                mz: [
                    {
                        required: true,
                        message: "请选择民族",
                        trigger: ["blur", "change"],
                    },
                ],
                bysj: [
                    {
                        required: true,
                        message: "请选择毕业时间",
                        trigger: ["blur", "change"],
                    },
                ],
                csny: [
                    {
                        required: true,
                        message: "请选择出生年月",
                        trigger: ["blur", "change"],
                    },
                ],
                zzmm: [
                    {
                        required: true,
                        message: "请选择政治面貌",
                        trigger: ["blur", "change"],
                    },
                ],
                sjhm: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: ["blur", "change"],
                    },
                    {
                        min: 11,
                        max: 11,
                        message: "手机号码必须为11位",
                        trigger: ["blur", "change"],
                    },
                ],
                jg: [
                    {
                        required: true,
                        message: "请输入籍贯",
                        trigger: ["blur", "change"],
                    },
                ],
                jtzz: [
                    {
                        required: true,
                        message: "请输入家庭住址",
                        trigger: ["blur", "change"],
                    },
                ],
                sl: [
                    {
                        required: true,
                        message: "请选择视力",
                        trigger: ["blur", "change"],
                    },
                ],
                sg: [
                    {
                        required: true,
                        message: "请选择身高",
                        trigger: ["blur", "change"],
                    },
                ],
                tz: [
                    {
                        required: true,
                        message: "请选择体重",
                        trigger: ["blur", "change"],
                    },
                ],
                dyxl: [
                    {
                        required: true,
                        message: "请选择学历",
                        trigger: ["blur", "change"],
                    },
                ],
                dyxlbyxx: [
                    {
                        required: true,
                        message: "请输入毕业学校",
                        trigger: ["blur", "change"],
                    },
                ],
                dyxlbysj: [
                    {
                        required: true,
                        message: "请输入毕业时间",
                        trigger: ["blur", "change"],
                    },
                ],
                xgzdw: [
                    {
                        required: true,
                        message: "请输入现工作单位",
                        trigger: ["blur", "change"],
                    },
                ],
                zwhgw: [
                    {
                        required: true,
                        message: "请输入现职务或岗位",
                        trigger: ["blur", "change"],
                    },
                ],
                mkjxgznx: [
                    {
                        required: true,
                        message: "请选择煤矿井下工作年限",
                        trigger: ["blur", "change"],
                    },
                ],
                xggwzgjndj: [
                    {
                        required: true,
                        message: "请选择相关岗位最高技能等级",
                        trigger: ["blur", "change"],
                    },
                ],
                gzpxxxjl: [
                    {
                        required: true,
                        message: "请输入个人履历",
                        trigger: ["blur", "change"],
                    },
                ],
            },
            options: {
                genderList: share.get("xb"),
                nationList: share.get("mz"),
                politicsFaceList: share.get("zzmm"),
                educationList: [
                    { key: "17", value: "研究生" },
                    { key: "20", value: "大学本科" },
                    { key: "30", value: "大学专科" },
                    { key: "40", value: "中等专科" },
                    { key: "61", value: "技工学校" },
                    { key: "60", value: "高中" },
                    { key: "70", value: "初中" },
                    { key: "80", value: "小学" },
                    { key: "98", value: "无" },
                ],
                slList: share.get("sl"),
                sgList: share.get("sg"),
                tzList: share.get("tz"),
                mkjxgznxList: share.get("mkjxgznx"),
                xggwzgjndjList: share.get("xggwzgjndj"),
            },
        };
    },
    watch: {
        "form.sfzhm": function (newValue) {
            if (newValue.length == 18) {
                this.form.xb =
                    parseInt(newValue.substr(16, 1)) % 2 == 1 ? "1" : "2"; //奇数男，偶数女
                this.form.csny =
                    newValue.substr(6, 4) +
                    "-" +
                    newValue.substr(10, 2) +
                    "-" +
                    newValue.substr(12, 2);
            }
        },
    },
    methods: {
        /**
         * 清除数据
         */
        clearField() {
            this.$refs.form.resetFields();
            this.fileSuccessList = [];
            this.fileFailList = [];
        },

        /**
         * 父组件获取校验后的数据
         */
        getData() {
            let data = {
                xm: this.form.xm, //姓名
                xb: this.form.xb, //性别
                mz: this.form.mz, //民族
                csrq: this.form.csny, //出生日期
                zzmm: this.form.zzmm, //政治面貌
                sfzhm: this.form.sfzhm, //有效证件号码
                sjhm: this.form.sjhm, //手机号码
                jg: this.form.jg, //家庭住址
                jtzz: this.form.jtzz, //家庭住址
                sl: this.form.sl, //视力
                sg: this.form.sg, //身高
                tz: this.form.tz, //体重
                dyxl: this.form.dyxl, //第一学历
                dyxlbyxx: this.form.dyxlbyxx, //第一学历毕业学校
                dyxlzy: this.form.dyxlzy, //第一学历专业
                dyxlbysj: this.form.dyxlbysj, //毕业时间
                cjgzsj: this.form.cjgzsj, //参加工作时间
                xgzdw: this.form.xgzdw, //现工作单位
                zwhgw: this.form.zwhgw, //职位或岗位
                mkjxgznx: this.form.mkjxgznx, //煤矿井下工作年限
                xggwzgjndj: this.form.xggwzgjndj, //相关岗位最高技能等级
                xggwczzgz: this.form.xggwczzgz, //相关岗位操作资格证
                gzpxxxjl: this.form.gzpxxxjl, //个人履历
                bz: this.form.bz, //备注

                sfzFileList: JSON.stringify(this.sfzFileSuccessList),
                byzFileList: JSON.stringify(this.byzFileSuccessList),
                gwzgzFileList: JSON.stringify(this.gwzgzFileSuccessList),
            };
            return data;
        },
        /**
         * 校验数据是否都已填写
         */
        validate() {
            let validated = false;
            this.$refs.form.validate((valid) => {
                if (valid) {
                    validated = true;
                } else {
                    validated = false;
                }
            });
            //检查是否已上传身份证
            if (this.sfzFileSuccessList.length === 0) {
                this.$message.error("请上传身份证附件！");
                validated = false;
            }
            //检查是否已上传身份证
            if (this.byzFileSuccessList.length === 0) {
                this.$message.error("请上传毕业证附件！");
                validated = false;
            }
            //检查是否已上传应聘岗位相关技能等级证或岗位资格证
            if (this.gwzgzFileSuccessList.length === 0) {
                this.$message.error("请上传应聘岗位相关技能等级证或岗位资格证附件！");
                validated = false;
            }

            return validated;
        },
        /**
         * 附件删除
         */
        deleteFile(index, type) {
            let fjxxid = "";
            if (type == "1") {
                fjxxid = this.sfzFileSuccessList[index].fjxxid;
            } else if (type == "2") {
                fjxxid = this.byzFileSuccessList[index].fjxxid;
            } else if (type == "3") {
                fjxxid = this.gwzgzFileSuccessList[index].fjxxid;
            }
            let param = {
                fjxxid: fjxxid,
            };
            request
                .delFile(param)
                .then((res) => {
                    console.log(res);
                    this.$message({
                        message: "删除成功! ",
                        type: "success",
                    });
                    if (type == "1") {
                        this.sfzFileSuccessList.splice(index, 1);
                    } else if (type == "2") {
                        this.byzFileSuccessList.splice(index, 1);
                    } else if (type == "3") {
                        this.gwzgzFileSuccessList.splice(index, 1);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        /**
         * 附件上传
         */
        setBMISection(type) {
            while (this.fileList.length > 0) {
                let fileData = new FormData();
                let item = this.fileList.shift();

                fileData.append("uploadfile", item.raw);
                fileData.append("filename", encodeURI(item.raw.name));
                fileData.append("fjlylx", "4");
                if (type == "1") {
                    fileData.append("bmdbh", "sfz_shhzp");
                    fileData.append("bmdmc", encodeURI("身份证"));
                }
                if (type == "2") {
                    fileData.append("bmdbh", "byz_shhzp");
                    fileData.append("bmdmc", encodeURI("毕业证"));
                }
                if (type == "3") {
                    fileData.append("bmdbh", "gwzgz_shhzp");
                    fileData.append(
                        "bmdmc",
                        encodeURI("应聘岗位相关技能等级证或岗位资格证")
                    );
                }

                request
                    .setBMISection(fileData)
                    .then((res) => {
                        console.log(res);
                        item.fjxxid = res.fjxxid;

                        if (type == "1") {
                            this.sfzFileSuccessList.push(item);
                        } else if (type == "2") {
                            this.byzFileSuccessList.push(item);
                        } else if (type == "3") {
                            this.gwzgzFileSuccessList.push(item);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        // this.$message({
                        //   // message: err,
                        //   message: "文件  " + item.raw.name + "  上传失败! " + err,
                        //   type: "error"
                        // });
                        if (type == "1") {
                            this.qzjlFileFailList.push(item);
                        } else if (type == "2") {
                            this.cjbFileFailList.push(item);
                        } else if (type == "3") {
                            this.jytjbFileFailList.push(item);
                        }
                    });
            }
        },
        /**
         * 附件上传文件添加回调方法
         */
        sfzUploadChange(file, fileList) {
            if (this.sfzFileSuccessList.length > 0) {
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过2MB!");
                this.$refs.sfzRef.clearFiles();
                return;
            }
            console.log(">>>:qzjlUploadChange");
            this.fileList = fileList;
            this.setBMISection("1");
        },
        byzUploadChange(file, fileList) {
            console.log(">>>:byzUploadChange", fileList);
            if (this.byzFileSuccessList.length > 5) {
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过2MB!");
                this.$refs.byzRef.clearFiles();
                return;
            }
            console.log(">>>:cjbUploadChange");
            this.fileList = fileList;
            this.setBMISection("2");
        },
        gwzgzUploadChange(file, fileList) {
            if (this.gwzgzFileSuccessList.length > 5) {
                fileList.shift();
                this.$message.error("请删除已上传文件后再上传新文件！");
                return;
            }

            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("上传附件大小不能超过2MB!");
                this.$refs.gwzgzRef.clearFiles();
                return;
            }
            console.log(">>>:jytjbUploadChange");
            this.fileList = fileList;
            this.setBMISection("3");
        },
    },
};
</script>

<style lang="scss" scoped>
.file-upload {
    display: flex;
    justify-content: space-between;
    .success {
        color: #12c3af;
    }
    .fail {
        color: #f56c6c;
    }
}
.baseinfo-image {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    .image {
        margin: 10px;
        padding: 20px;
        width: 150px;
        height: 180px;
    }
}
.red {
    color: #f56c6c;
}
.show {
    display: block;
}
.hide {
    display: none;
}
.header {
    font-weight: bold;
    padding: 10px;
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.modify {
    color: #2a8ae0;
    &:hover {
        cursor: pointer;
    }
}
.delete {
    color: #ff5858;
    &:hover {
        cursor: pointer;
    }
}
.attachments-section {
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;

    .el-row {
        width: 100%;
    }

    .upload-hint {
        color: red;
        margin-left: 5px;
        font-weight: normal;
        font-size: 13px;
    }

    .attachment-card {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        margin-bottom: 20px;
        background-color: #fafafa;

        .card-header {
            padding: 12px 15px;
            border-bottom: 1px solid #ebeef5;
            font-weight: bold;
            display: flex;
            align-items: center;

            i {
                margin-right: 8px;
                color: #409eff;
            }

            .required {
                color: red;
                margin-left: 4px;
            }
        }

        .card-body {
            padding: 15px;

            .upload-demo {
                margin-bottom: 10px;
            }

            .upload-message {
                color: #f56c6c;
                font-size: 12px;
            }
        }
    }

    .general-attachments {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        margin-top: 20px;
        background-color: #fbfbfb;

        .card-header {
            padding: 12px 15px;
            border-bottom: 1px solid #ebeef5;
            font-weight: bold;
            display: flex;
            align-items: center;

            i {
                margin-right: 8px;
                color: #409eff;
            }
        }

        .upload-area {
            padding: 15px;
        }
    }

    .file-list-container {
        padding: 0 15px 15px;

        .file-section {
            margin-top: 15px;

            .section-title {
                font-weight: bold;
                margin-bottom: 10px;
                padding-bottom: 5px;
                border-bottom: 1px solid #ebeef5;
            }

            .success-title {
                color: #67c23a;
            }

            .fail-title {
                color: #f56c6c;
            }
        }
    }

    .file-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 10px;
    }

    .file-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        background-color: white;

        i:first-child {
            color: #409eff;
            margin-right: 8px;
        }

        .file-name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .delete-icon {
            color: #f56c6c;
            cursor: pointer;
            margin-left: 8px;

            &:hover {
                opacity: 0.8;
            }
        }
    }

    .success-item {
        border-color: #d1edff;
        background-color: #ecf5ff;
    }

    .fail-item {
        border-color: #fde2e2;
        background-color: #fef0f0;

        .file-actions {
            display: flex;
            align-items: center;

            .retry-text {
                color: #409eff;
                cursor: pointer;
                margin-right: 8px;
                font-size: 12px;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}
.input-tip {
    color: #f70808;
    font-size: 12px;
    margin-top: 5px;
}
</style>
